<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import Button from 'primevue/button';
import ApplicationLogo from '@/Components/ApplicationLogo.vue';

const page = usePage();
</script>

<template>
  <Head title="Chèques cadeaux"/>

  <div class="min-h-full">
    <header class="pt-8 pb-4 flex justify-center">
      <ApplicationLogo class="w-72"/>
    </header>

    <main
        class="relative max-w-2xl px-4 py-4 sm:px-6 lg:px-8 flex flex-col justify-center sm:items-center mx-auto size-full">
      <div class="text-center pb-4 px-4 sm:px-6 lg:px-8 size-full">
        <h1 class="text-xl sm:text-2xl text-primary uppercase font-semibold">
          Commande de chèques cadeaux en promotion
        </h1>
      </div>

      <div class="mt-8 flex flex-col gap-8 text-center">
        <p>
          Les chèques-cadeaux vendus en promotion sont épuisés.
        </p>

        <p>
          Néanmoins, Mon Shopping C'est Calais en vend toute l'année et vous permet de faire plaisir à vos proches
          à chaque évènement spécial.
        </p>

        <!--
        <p>
          <Button as="a" href="https://monshoppingcestcalais.fr/cheques-cadeaux.html" class="font-bold">
            Retrouver les chèques cadeaux sur Mon Shopping C'est Calais
          </Button>
        </p>
        -->
      </div>
    </main>
  </div>
</template>